import React, { useEffect, useState } from "react";
import bootstrap from "bootstrap/dist/js/bootstrap.min.js";
import Select from "react-dropdown-select";
import axiosInstance from "../../services/api/axiosInstance";
import { Link } from "react-router-dom";

const DoubleButton = ({
  id,
  firstButtonName,
  secondButtonName,
  cardIcon,
  firstCardColorclassName,
  secondCardColorclassName,
  rightLearnUrl,
  leftCommUrl,
  leftLearnUrl,
  rightCommUrl,
  dropDownName,
  handleOpen,
  handlePause,
  handleClose,
  jobId,
  handleCandidateRadioButton,
  getAppliedCandidateSearch,
  candidateDetails,
  setCandidateDetails,
  radioValue,
  setRadioValue,
  candidateName,
  candidateFeedbackDb,
  setCandidateFeedbackDb,
  handleCandidateFeedbackDb,
  appliedCandidates,
  setClosingCandidateDetails,
  openValue,
  handleRedirectToCandidate,
  role,
  dataFrom,
  type_of_community
}) => {
  const [selectBoxCandidates, setSelectBoxCandidates] = useState([]);


  useEffect(() => {
    if (appliedCandidates !== undefined) {
      var convertAppliedData = appliedCandidates.map((v, i) => {
        return { value: v.id, label: `${v.first_name} ${v.last_name}` };
      });

      setSelectBoxCandidates(convertAppliedData);
    }
  }, [appliedCandidates]);

  const handleButtonDropDown = (drop) => {
    if (drop === "Close") {
      setRadioValue("Y")
      setCandidateDetails(true)
      getAppliedCandidateSearch(jobId)
      const closeModal = new bootstrap.Modal(`#closeModal${jobId}`);
      closeModal.show();
    }

    if (drop === "Open") {
      const openModal = new bootstrap.Modal(`#openModal${jobId}`);
      openModal.show();
    }

    if (drop === "Pause") {
      const pauseModal = new bootstrap.Modal(`#pauseModal${jobId}`);
      pauseModal.show();
    }
  };

  const handleModalCancelButton = (e, drop) => {
    if (drop === "Close") {
      setRadioValue('Y')
      setCandidateDetails(true)
      setCandidateFeedbackDb("")
    }
  };

  const handleViewCount = async () => {
    const viewParams = {
      "partner_id": id
    }
    try {
      const response = await axiosInstance.post("/update_partner_view_count", viewParams)
      if (response.data.error_code === 0) {
      }
    }
    catch (err) {
      console.log(err)
    }
  }

  return (
    <div className="d-grid gap-2 d-md-flex justify-content-md-center mb-2 mx-1">


      {/*Community  left button*/}
      {firstButtonName === "Join Community" ? (
        <a
          id={`joinCommunity${id}Button`}
          href={(leftCommUrl).includes("https://") ? leftCommUrl : `https://${leftCommUrl}`}
          role="button"
          target="_blank"
          className={`btn btn-${firstCardColorclassName} me-md-2 w-100`}
        >
          {cardIcon}
          {firstButtonName}
        </a>



        // Emloyer left Dropdown  Button
      ) : firstButtonName === "Open" ? (
        <div className="dropdown custom-dropdown w-100 pt-3 pt-sm-0">
          {
            openValue !== "closed" ?
              <>
                <button
                  id={`employerStatusBottom${jobId}Button`}
                  className="btn btn-secondary dropdown-toggle rounded-3 me-md-2 w-100 mx-auto"
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  {" "}
                  <span className="px-3">
                    {dropDownName !== "" ? dropDownName === 'opened' ? 'Open' : dropDownName === 'paused' ? 'Paused' : 'Closed' : firstButtonName}
                  </span>
                </button>
                <ul className="dropdown-menu border-0 shadow">
                  {
                    openValue !== "opened" ?
                      <>
                        <li
                          id={`employerOpen${jobId}Button`}
                          onClick={() => {
                            handleButtonDropDown("Open");
                          }}
                        >
                          <a className="dropdown-item fw-medium">Open</a>
                        </li>
                        <hr className="m-0 mx-3 buttonLineColor" />
                      </>
                      :
                      null
                  }


                  <li
                    id={`employerClose${jobId}Button`}
                    onClick={() => {
                      handleButtonDropDown("Close");
                    }}
                  >
                    <a className="dropdown-item fw-medium">Close</a>
                  </li>
                  <hr className="m-0 mx-3 buttonLineColor" />

                  {
                    openValue !== "paused" ?
                      <>
                        <li
                          id={`employerPause${jobId}Button`}
                          onClick={() => {
                            handleButtonDropDown("Pause");
                          }}
                        >
                          <a className="dropdown-item fw-medium">Pause</a>
                        </li>
                      </>
                      :
                      null
                  }
                </ul>
              </>
              :
              <button
                className="btn btn-transparent border pe-none  rounded-3 me-md-2 w-100 mx-auto"
                type="button"
              >
                Closed
              </button>
          }
        </div>
      ) : (

        // Register Here Button
        firstButtonName === "Register here" ? (
          // <a
          //   id={`joinCommunity${id}Button`}
          //   // href={(leftCommUrl).includes("https://") ? leftCommUrl : `https://${leftCommUrl}`}
          //   href={leftCommUrl}
          //   role="button"
          //   target="_blank"
          //   className={`btn btn-${firstCardColorclassName} me-md-2 w-100`}
          // >
          //   {cardIcon}
          //   {firstButtonName}
          // </a>
          <Link to={leftCommUrl} className={`btn btn-${firstCardColorclassName} me-md-2 w-100`}>
            {cardIcon}
            {firstButtonName}
          </Link>
        )

          :
          firstButtonName === "Download" && role === "learning" ?

            // Learning Download Button
            leftLearnUrl.length <= 21 ? null :
              <a
                id={`learningDownload${id}Button`}
                href={`${process.env.REACT_APP_SECOND_CAREERS_CDN}${leftLearnUrl}`}
                download
                className={leftLearnUrl === '' ? `btn btn-${firstCardColorclassName}  me-md-2 w-100 disabled` : `btn btn-${firstCardColorclassName}  me-md-2 w-100`}
                type="button"
              >
                {cardIcon}
                {firstButtonName}
              </a>

            :
            null

      )

      }

      {/* community Right button */}
      {secondButtonName === "Share" ? (
        <button
          id={`communityShare${id}Button`}
          className={`btn btn-${secondCardColorclassName} w-100`}
          type="button"
          onClick={() => (secondButtonName === "Share" ? "" : "")}
          data-bs-toggle="modal"
          data-bs-target={secondButtonName === "Share" ? `#share${id}Modal` : ""}
        >
          {secondButtonName}
        </button>



        // Employer View Button
      ) : secondButtonName === "View" ? (
        <button id={`employerView${jobId}Button`} type="button" className={`btn btn-${secondCardColorclassName} w-100`} onClick={() => handleRedirectToCandidate(jobId)}>View&nbsp;Applicants</button>

      ) :

        secondButtonName === "Learn more" || secondButtonName === "Read more" && rightCommUrl != "" ?

          (
            <a
              id={`communityDownload${id}Button`}
              href={(rightCommUrl).includes("https://") ? rightCommUrl : `https://${rightCommUrl}`}
              role="button"
              target="_blank"
              className={`btn btn-${secondCardColorclassName} w-100`}
              type="button"
              onClick={handleViewCount}
            >
              {cardIcon}
              {type_of_community ? "Play video" : secondButtonName}
            </a>
          )

          :

          secondButtonName === "Preview" ?

            (
              <a
                id={`communityPreview${id}Button`}
                href={(rightCommUrl).includes("https://") ? rightCommUrl : `https://${rightCommUrl}`}
                role="button"
                target="_blank"
                className={`btn btn-${secondCardColorclassName} w-100`}
                type="button"
              // data-bs-toggle="modal"
              // data-bs-target={`#preview${id}Modal`}
              // onClick={handleViewCount}
              >
                {cardIcon}
                {secondButtonName}
              </a>
            )

            :


            (

              // learning Right Button
              <a
                id={`learningLearnMore${id}Button`}
                href={(rightLearnUrl).includes("https://") ? rightLearnUrl : `https://${rightLearnUrl}`}
                role="button"
                target="_blank"
                className={`btn btn-${secondCardColorclassName} w-100`}
                onClick={dataFrom !== "professionalHome" ? null : handleViewCount}
              >
                {secondButtonName}
              </a>
            )


      }



      {/* Open Modal */}
      <div
        className="modal fade"
        id={`openModal${jobId}`}
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-md">
          <div className="modal-content p-3">
            <div className="modal-body">
              <form>
                <div>
                  <span className="yesOrNoText">
                    Click submit to open this job ?
                  </span>
                </div>
              </form>
            </div>
            <div className="modal-footer border-0 bg-transparent pb-2">
              <button
                id={`openModalCancel${jobId}Button`}
                type="button"
                className="btn btn-outline-secondary"
                data-bs-dismiss="modal"
              >
                Cancel
              </button>
              <button
                id={`openModalSubmit${jobId}Button`}
                type="button"
                className="btn btn-brand-color ms-3"
                data-bs-dismiss="modal"
                onClick={(e) => handleOpen(e, jobId, openValue)}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Pause button Modal*/}
      <div
        className="modal fade"
        id={`pauseModal${jobId}`}
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-md">
          <div className="modal-content p-3">
            <div className="modal-body">
              <form>
                <div className="">
                  <label
                    htmlFor="recipient-name"
                    className="col-form-label col"
                  >
                    Are you sure you want to pause this job ?
                  </label>
                </div>
              </form>
            </div>
            <div className="modal-footer border-0 bg-transparent pb-2">
              <button
                id={`pauseModalCancel${jobId}Button`}
                type="button"
                className="btn btn-outline-secondary"
                data-bs-dismiss="modal"
              >
                Cancel
              </button>
              <button
                id={`pauseModalSubmit${jobId}Button`}
                type="button"
                className="btn btn-brand-color ms-3"
                data-bs-dismiss="modal"
                onClick={(e) => handlePause(e, jobId, openValue)}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Close button Modal */}
      <div
        className="modal fade"
        id={`closeModal${jobId}`}
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content p-3">

            <div className="modal-header border-0">
              <button type="button" className="btn-close" data-bs-dismiss="modal" id={`closeModal-${jobId}`} onClick={(e) => handleModalCancelButton(e, 'Close')}></button>
            </div>

            <div className="modal-body">
              <form>
                <div className=" row align-items-center w-100">
                  <div className=" d-flex align-items-center justify-content-between  w-100">
                    <div className={`textWithRadio col-9`} id={"fillThisRole"}>
                      <label htmlFor={"fillThisRole"} className="col-form-label col">{"Were you able to fill this role through 2nd Careers ?"}</label>
                    </div>

                    <div className="yesOrNo col-3">
                      <div className="d-flex align-items-center w-100">
                        <div className=" col mx-auto flex-fill me-2">
                          <input className="form-check-input yesOrNoRadioButtonColor me-1" type="radio" value={"Y"} name={"radiocommonName"} checked={radioValue === "Y"} id={`roleOne${jobId + 'abytr'}`}
                            onChange={(e) => handleCandidateRadioButton(e, jobId)} />
                          <label htmlFor={`roleOne${jobId + 'abytr'}`}>Yes</label>
                        </div>

                        <div className=" col mx-auto flex-fill">
                          <input className="form-check-input yesOrNoRadioButtonColor me-1" type="radio" value={"N"} name={"radiocommonName"} checked={radioValue === "N"} id={`roleTwo${jobId + 'qbra'}`}
                            onChange={(e) => handleCandidateRadioButton(e, jobId)} />
                          <label htmlFor={`roleTwo${jobId + 'qbra'}`}>No</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {candidateDetails ? (
                  <React.Fragment>
                    <div className="mb-3">
                      <label
                        htmlFor="recipient-name"
                        className="col-form-label"
                      >
                        Please select the hired candidate
                      </label>

                      <Select
                        multi
                        color="#ffa32d"
                        style={{ fontSize: ".9rem" }}
                        className="rounded-1"
                        options={selectBoxCandidates}
                        onChange={(values) => setClosingCandidateDetails(values)}
                      />

                    </div>
                  </React.Fragment>
                ) : null}
                <div>
                  <label htmlFor="message-text" className="col-form-label">
                    Kindly provide your feedback regarding posting this job through 2nd Careers
                  </label>
                  <textarea
                    className="form-control"
                    id={`feedback${jobId}Field`}
                    value={candidateFeedbackDb}
                    onChange={(e) => handleCandidateFeedbackDb(e)}
                  ></textarea>
                </div>

              </form>
            </div>
            <div className="modal-footer border-0 bg-transparent pb-2">
              <button
                id={`closeModalCancel${jobId}Button`}
                type="button"
                className="btn btn-outline-secondary"
                data-bs-dismiss="modal"
                onClick={(e) => handleModalCancelButton(e, 'Close')}
              >
                Cancel
              </button>
              <button
                id={`closeModalSubmit${jobId}Button`}
                type="button"
                className="btn btn-brand-color ms-3"
                onClick={(e) =>
                  handleClose(
                    e,
                    radioValue,
                    candidateName,
                    candidateFeedbackDb,
                    jobId
                  )
                }
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DoubleButton;
